var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallStar = function SvgSmallStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m8.867 3.448-2.48-.36L5.28.84a.314.314 0 0 0-.56 0L3.61 3.088l-2.48.36a.312.312 0 0 0-.172.533l1.794 1.75-.424 2.47a.312.312 0 0 0 .453.328l2.218-1.166L7.217 8.53a.312.312 0 0 0 .453-.33l-.424-2.469 1.794-1.75a.312.312 0 0 0-.173-.533"
  })));
};
export default SvgSmallStar;